import { isNavigationToAnotherPage, startNavigationProgress } from '@/shared/lib/topProgress';

export const onRouterTransitionStart = (url: string): void => {
  if (isNavigationToAnotherPage(url, new URL(window.location.href))) startNavigationProgress();
};
